// Helper for private/auth/admin routes that should not be indexed.
// Emits proper title + `noindex,nofollow` and keeps the legacy bridge component.
import { getHost } from "@/lib/host";
import { canonicalOriginFromHost, localeFromHost, type LocaleKey } from "@/lib/locale-from-host";

export type NoindexSEO = Record<LocaleKey, string>;

export function noindexLoader() {
  const host = getHost();
  return {
    locale: localeFromHost(host),
    origin: canonicalOriginFromHost(host),
  };
}

export function buildNoindexHead(
  titles: NoindexSEO,
  path: string,
  loaderData: { locale: LocaleKey; origin: string } | undefined,
) {
  const locale = loaderData?.locale ?? "es";
  const origin = loaderData?.origin ?? "https://www.foradarota.com";
  const title = `${titles[locale]} | Fora da Rota`;
  return {
    meta: [
      { title },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: title },
      { property: "og:url", content: `${origin}${path}` },
    ],
  };
}
